import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { RawTableComponent } from './raw-table/raw-table.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [HomeComponent, RawTableComponent]
})
export class HomeModule { }



// WEBPACK FOOTER //
// ./src/app/home/home.module.ts